import React, { useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Button,
  DataTable,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableExpandHeader,
  TableExpandRow,
  TableExpandedRow,
  TableHead,
  TableHeader,
  TableRow,
  TableToolbar,
  TableToolbarContent,
  TableToolbarSearch
} from "@carbon/react";
import { Filter } from "@carbon/icons-react";
import DailyReportModal from "./DailyReportModal.container";
import { onGetTruckModalThunk } from "./DailyReport.actions";
import { useSorting } from "../../../modules/hooks/sorting";

const DailyCycleReportTable = () => {
  const dispatch = useDispatch();
  const button = useRef();
  const [open, setOpen] = useState(false);
  const { cycleTable } = useSelector((state) => state.daily);

  const headerData = [
    { header: "Tipo Ciclo", key: "tipo_ciclo" },
    { header: "M3 Transportados Promedio (Pórtico)", key: "Camion_Volumen_m3" },
    { header: "Distancia Recorrida Promedio", key: "distancia_recorrida (km)" },
    { header: "Velocidad Promedio", key: "kph_mean" },
    { header: "M3 por Km movido", key: "m3/km" },
    { header: "Cantidad de Ciclos", key: "ciclo" }
  ];

  const { rows, headers } = useSorting(cycleTable, headerData);

  const Default = () => (
    <DataTable rows={rows} headers={headers} width="100%">
      {({
        rows,
        headers,
        getHeaderProps,
        getRowProps,
        getTableProps,
        getTableContainerProps,
        onInputChange,
        sortBy
      }) => (
        <TableContainer {...getTableContainerProps()}>
          <Table {...getTableProps()} aria-label="sample table">
            <TableHead>
              <TableRow>
                {headers.map((header, i) => {
                  const { key, ...headerProps } = getHeaderProps({ header }); // Extract `key`
                  return (
                    <TableHeader key={key} {...headerProps} sortDirection={headerData[i]?.sortDirection ?? "NONE"}>
                      {header.header}
                    </TableHeader>
                  );
                })}
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map((row) => {
                const { key, ...rowProps } = getRowProps({ row }); // Extract `key`
                return (
                  <TableRow key={key} {...rowProps}>
                    {row.cells.map((cell) => (
                      <TableCell key={cell.id}>{cell.value}</TableCell>
                    ))}
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </DataTable>
  );

  return <Default />;
};

export default DailyCycleReportTable;
